module.exports = __webpack_public_path__ + "img/logo-pa.74bb2944.png";